import React from 'react'
import style from './amountCardPlus.module.scss'
import VegaColors from '../../../resources/constants/colors.module.scss'
import { VegaHeading } from '../../../components/vega/heading/Heading'
import { useTranslation } from 'react-i18next'
import { VegaTypo } from '../../vega/typography/Typography'
import { VegaTooltip } from '../../vega/tooltip/Tooltip'
import { VegaIcon } from '../../vega/icon/Icon'
import { VegaCopy } from '../../vega/copy/Copy'
import { PropTypes } from 'prop-types'
import cx from 'classnames'

/**
 * Column in the AmountCard that show details (plus) datas
 */
const AmountCardPlus = ({ label, value, labelTip, valueCopy }) => {
	const { t } = useTranslation()

	if (value === null) {
		return null
	}

	return (
		<div className={cx(style.plus)}>
			<div className={style.label}>
				<VegaHeading tag={'h7'} label={t(label)} className={style.heading} />
				{labelTip && (
					<VegaTooltip label={labelTip}>
						<VegaIcon color={VegaColors.CONTENTBLACKMINOR} name={'indicator-info'} />
					</VegaTooltip>
				)}
			</div>
			<div className={style.value}>
				<VegaTypo label={value} className={style.typo} />
				{valueCopy && <VegaCopy value={value} />}
			</div>
		</div>
	)
}

AmountCardPlus.propTypes = {
	/** Title of Amount Card Plus */
	label: PropTypes.string,
	/** Value of Amount Card Plus */
	value: PropTypes.string,
	/** Label of Tooltip */
	labelTip: PropTypes.string,
	/** Enable to copying value */
	valueCopy: PropTypes.bool
}

export { AmountCardPlus }
